// removed by extract-text-webpack-plugin
module.exports = {"message":"c-FieldMessage__message","error":"c-FieldMessage__error"};